import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../api";

const STATUSES = [
  { id:"new",           label:"New",           color:"#6b7280", bg:"#6b728018" },
  { id:"contacted",     label:"Contacted",     color:"#60a5fa", bg:"#60a5fa18" },
  { id:"interested",    label:"Interested",    color:"#f59e0b", bg:"#f59e0b18" },
  { id:"follow_up",     label:"Follow Up",     color:"#a855f7", bg:"#a85507" },
  { id:"converted",     label:"Converted",     color:"#00d4aa", bg:"#00d4aa18" },
  { id:"not_interested",label:"Not Interested",color:"#f87171", bg:"#f8717118" },
];

export default function CRM() {
  const [leads, setLeads]       = useState([]);
  const [pipeline, setPipeline] = useState({});
  const [loading, setLoading]   = useState(true);
  const [search, setSearch]     = useState("");
  const [filter, setFilter]     = useState("all");
  const [updating, setUpdating] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    Promise.all([
      API.get("/leads"),
      API.get("/stats"),
    ]).then(([lr, pr]) => {
      setLeads(lr.data.leads || []);
      const s = pr.data || {};
      setPipeline({
        new: Math.max(0,(s.total||0)-(s.contacted||0)-(s.converted||0)),
        contacted: s.contacted||0,
        interested: s.hot||0,
        converted: s.converted||0,
        follow_up: s.warm||0,
        not_interested: s.cold||0,
      });
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  const updateStatus = async (lead, status) => {
    setUpdating(lead._id);
    try {
      await API.post("/leads/status", { lead_id: lead._id, status, note: "" });
      setLeads(ls => ls.map(l => l._id === lead._id ? {...l, status: status, status} : l));
      setPipeline(p => {
        const np = {...p};
        const old = lead.status || "new";
        np[old] = Math.max(0, (np[old]||0) - 1);
        np[status] = (np[status]||0) + 1;
        return np;
      });
    } catch(e) { alert("Failed to update status"); }
    setUpdating(null);
  };


  const filtered = leads.filter(l => {
    const q = search.toLowerCase();
    const matchQ = !q || (l.name||"").toLowerCase().includes(q) || (l.phone||"").includes(q);
    const matchF = filter === "all" || (l.status||"new") === filter;
    return matchQ && matchF;
  });

  const S = {
    page: { minHeight:"100vh", background:"#050510", color:"#fff", fontFamily:"'DM Sans',sans-serif", padding:28 },
    card: { background:"linear-gradient(135deg,#0d0d1f,#111128)", border:"1px solid #ffffff0a", borderRadius:16, padding:"16px 20px", marginBottom:10 },
    badge: (s) => { const st = STATUSES.find(x=>x.id===s)||STATUSES[0]; return { background:st.bg, color:st.color, border:`1px solid ${st.color}44`, borderRadius:8, padding:"3px 10px", fontSize:11, fontWeight:700 }; },
  };

  return (
    <div style={S.page}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;700&family=Syne:wght@900&display=swap" rel="stylesheet"/>
      <div style={{ maxWidth:1100, margin:"0 auto" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:28 }}>
          <div>
            <h1 style={{ fontFamily:"'Syne',sans-serif", fontSize:26, fontWeight:900, margin:0 }}>📋 CRM Pipeline</h1>
          </div>
          <button onClick={() => navigate("/dashboard")} style={{ background:"transparent", color:"#9ca3af", border:"1px solid #ffffff22", borderRadius:10, padding:"9px 16px", cursor:"pointer", fontSize:13, fontFamily:"'DM Sans',sans-serif" }}>← Dashboard</button>
        </div>

        {/* Pipeline stats */}
        <div style={{ display:"grid", gridTemplateColumns:"repeat(6,1fr)", gap:10, marginBottom:24 }}>
          {STATUSES.map(s => (
            <div key={s.id} onClick={() => setFilter(filter===s.id?"all":s.id)} style={{ background: filter===s.id?s.bg:"#0d0d1f", border:`1px solid ${filter===s.id?s.color+"44":"#ffffff0d"}`, borderRadius:12, padding:"14px 12px", textAlign:"center", cursor:"pointer", transition:"all 0.2s" }}>
              <div style={{ fontFamily:"'Syne',sans-serif", fontSize:24, fontWeight:900, color:s.color }}>{pipeline[s.id]||0}</div>
              <div style={{ color:"#9ca3af", fontSize:11, marginTop:4 }}>{s.label}</div>
            </div>
          ))}
        </div>

        {/* Search */}
        <div style={{ display:"flex", gap:12, marginBottom:20 }}>
          <input placeholder="Search by name or phone..." value={search} onChange={e=>setSearch(e.target.value)} style={{ flex:1, background:"#0d0d1f", border:"1px solid #ffffff11", borderRadius:10, padding:"11px 16px", color:"#fff", fontFamily:"'DM Sans',sans-serif", fontSize:14, outline:"none" }}/>
          <select value={filter} onChange={e=>setFilter(e.target.value)} style={{ background:"#0d0d1f", border:"1px solid #ffffff11", borderRadius:10, padding:"11px 14px", color:"#fff", fontFamily:"'DM Sans',sans-serif", fontSize:14, outline:"none" }}>
            <option value="all">All Leads</option>
            {STATUSES.map(s => <option key={s.id} value={s.id}>{s.label}</option>)}
          </select>
        </div>

        {/* Leads */}
        {loading ? (
          <div style={{ textAlign:"center", padding:60, color:"#6b7280" }}>Loading...</div>
        ) : filtered.length === 0 ? (
          <div style={{ textAlign:"center", padding:60, color:"#6b7280" }}>
            <div style={{ fontSize:40, marginBottom:12 }}>📋</div>
            No leads yet. <span onClick={() => navigate("/search")} style={{ color:"#00d4aa", cursor:"pointer" }}>Search for leads →</span>
          </div>
        ) : filtered.map((lead, i) => (
          <div key={i} style={S.card}>
            <div style={{ display:"grid", gridTemplateColumns:"1fr auto", gap:16, alignItems:"start" }}>
              <div>
                <div style={{ fontWeight:700, fontSize:15, marginBottom:6 }}>{lead.name}</div>
                <div style={{ display:"flex", gap:16, fontSize:13, flexWrap:"wrap", marginBottom:8 }}>
                  {lead.phone   && <span style={{ color:"#00d4aa", fontWeight:600 }}>📞 {lead.phone}</span>}
                  {lead.address && <span style={{ color:"#9ca3af" }}>📍 {lead.address.slice(0,50)}</span>}
                  {lead.rating > 0 && <span style={{ color:"#f59e0b" }}>⭐ {lead.rating}</span>}
                </div>
                {/* Status buttons */}
                <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
                  {STATUSES.map(s => (
                    <button key={s.id} onClick={() => updateStatus(lead, s.id)} disabled={updating===lead._id} style={{ background: (lead.status||"new")===s.id ? s.bg : "transparent", color: (lead.status||"new")===s.id ? s.color : "#6b7280", border:`1px solid ${(lead.status||"new")===s.id?s.color+"44":"#ffffff11"}`, borderRadius:8, padding:"4px 10px", fontSize:11, cursor:"pointer", fontFamily:"'DM Sans',sans-serif", fontWeight:700, transition:"all 0.15s" }}>
                      {s.label}
                    </button>
                  ))}
                </div>
              </div>
              <div style={{ display:"flex", flexDirection:"column", gap:8, alignItems:"flex-end" }}>
                <span style={S.badge(lead.status||"new")}>{STATUSES.find(s=>s.id===(lead.status||"new"))?.label||"New"}</span>
                <span style={{ background:"#00d4aa18", color:"#00d4aa", border:"1px solid #00d4aa44", borderRadius:8, padding:"3px 10px", fontSize:11, fontWeight:700 }}>Score: {lead.score||"?"}</span>

                {lead.phone && (
                  <a href={`tel:${lead.phone}`} style={{ background:"#60a5fa18", color:"#60a5fa", border:"1px solid #60a5fa44", borderRadius:8, padding:"6px 12px", fontSize:12, textDecoration:"none", fontWeight:700 }}>
                    📞 Call
                  </a>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
